var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSoundcloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 24 24",
    viewBox: "0 0 24 24",
    className: "sc-gKsewC hxdUPG",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    "data-testid": "svgTitle",
    id: titleId || "title_0.3965574203370432"
  }, "soundcloud") : title ? /*#__PURE__*/React.createElement("title", {
    "data-testid": "svgTitle",
    id: titleId || "title_0.3965574203370432"
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.119,19.071H9.262a.5.5,0,0,1,0-1h9.857a3.881,3.881,0,1,0,0-7.761,1.084,1.084,0,0,0-.161.016l-.165.019a.482.482,0,0,1-.515-.334A6.055,6.055,0,0,0,9.513,6.748a.5.5,0,0,1-.5-.866A7.056,7.056,0,0,1,19.082,9.31h.037a4.881,4.881,0,1,1,0,9.761Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M.5,17.429a.5.5,0,0,1-.5-.5V10.357a.5.5,0,0,1,1,0v6.572A.5.5,0,0,1,.5,17.429Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.238,19.071a.5.5,0,0,1-.5-.5V7.619a.5.5,0,0,1,1,0V18.571A.5.5,0,0,1,3.238,19.071Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.977,19.071a.5.5,0,0,1-.5-.5V8.714a.5.5,0,0,1,1,0v9.857A.5.5,0,0,1,5.977,19.071Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoundcloud);
export default __webpack_public_path__ + "static/media/soundcloud.afe49f8aca0f362f8f2d51274b6fec4f.svg";
export { ForwardRef as ReactComponent };